import React, { useState } from 'react'
import { useRef } from 'react';

export const InfoPqr3 = ({ onInputChange, formState, setArchivos }) => {

  const inputFileRef = useRef(null);

  const handleFileChange = (e) => {
    const { files } = e.target;
    setArchivos(files);
  };

  const handleDeleteAllFiles = () => {
    setArchivos([]);
    if (inputFileRef.current) {
      inputFileRef.current.value = null;
    }
  };


  return (
    <div className="contenedorInfo">

      {/* TITULO */}

      <div className="contenedorTitulo">
        <h1>
          INFORMACION DE LA SOLICITUD
        </h1>

      </div>

      <div className="contenedorFormulario">

        <div className="contIzquierda">

          {/* TIPO DE SOLICITUD */}

          <div className="contTipoid">
            <div className="contPregunta">
              <div className="labelform">
                <label For="tipoSolicitud"> (*) Tipo de Solicitud </label>
              </div>
            </div>
            <div className="contRespuesta">

              <div className="contIcono">
                <i className="iconoSolicitud"></i>
              </div>
              <div className="contSelect">
                <select
                  name='tipoSolicitud'
                  value={formState.tipoSolicitud}
                  onChange={onInputChange}
                  id="idTiposoli"
                  className="selectform"
                  tabIndex={1}
                  required
                >
                  <option value="" selected disabled>Seleccione el tipo de Solicitud</option>
                  <option value="Consulta Datos Personales">Consulta Datos Personales</option>
                  <option value="Derecho Peticion">Derecho Petición</option>
                  <option value="Felicitacion">Felicitación</option>
                  <option value="Queja">Queja</option>
                  <option value="Reclamacion Datos Personales">Reclamación Datos Personales</option>
                  <option value="Reclamo">Reclamo</option>
                  <option value="Solicitud de Documentacion">Solicitud de Documentación</option>
                  <option value="Sugerencia">Sugerencia</option>
                </select>
              </div>
            </div>
          </div>

          {/* DESCRIPCION */}

          <div className="contTipoid">
            <div className="contPregunta1">
              <div className="contIcono2">
                <i className="iconoDescripcion"></i>
              </div>
              <div className="labelform">
                <label For="descripcion"> (*) Descripción </label>
              </div>
            </div>
            <div className="contRespuesta1">
              <div className="contText">
                <div className="textform1">
                  <textarea
                    name='descripcion'
                    value={formState.descripcion}
                    onChange={onInputChange}
                    className="textformdet1"
                    id="idDescripcion"
                    cols="30"
                    rows="10"
                    tabIndex={3}
                    placeholder="Digite aquí todo el contenido de su solicitud" required
                  >
                  </textarea>
                </div>
              </div>
            </div>
          </div>

        </div>


        <div className="contDerecha">

          {/* ASUNTO */}

          <div className="contTipoid">
            <div className="contPregunta">
              <div className="labelform">
                <label For="asunto"> (*) Asunto </label>
              </div>
            </div>
            <div className="contRespuesta1">

              <div className="contIcono1">
                <i className="iconoAsunto"></i>
              </div>
              <div className="contText">
                <div className="textform">
                  <input
                    name='asunto'
                    value={formState.asunto}
                    onChange={onInputChange}
                    className="textformdet"
                    type="text"
                    tabIndex={2}
                    placeholder="Digite el asunto de su solicitud"
                    required
                  />
                </div>
              </div>
            </div>
          </div>

          {/* ADJUNTAR ARCHIVOS */}

          <div className="contTipoid">
            <div className="contPregunta1">
              <div className="contIcono2">
                <i className="iconoAdjuntar"></i>
              </div>
              <div className="labelform">
                <label For="adjArchivos"> Adjuntar  Archivos </label>
              </div>
            </div>
            <div className="contRespuesta1">
              <div className="contText">
                <div className="textformTrash">
                  <div className='containerArchivos'>
                    <input
                      name='archivos'
                      onChange={handleFileChange}
                      className="cargaArchivos"
                      type="file"
                      multiple
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.txt"
                      tabIndex={4}
                      id='idArchivo'
                      ref={inputFileRef}
                    />
                  </div>
                  {formState.archivos && formState.archivos.length > 0 &&
                    <div className='containerTrash'>
                      <img className='iconoTrash' src='../../icons/trash.svg'></img>
                      <button onClick={handleDeleteAllFiles}>Eliminar archivos</button>
                    </div>
                  }
                </div>


                <div className="contAdjuntar">

                  <p className='parrafoAdj'>
                    Ingrese aquí todos los archivos anexos que contenga su solicitud,
                    aquí podrá cargar hasta 20 archivos anexos en los formatos
                    "docx, doc, pdf, xls, xlsx, png, jpg, jpeg, txt"
                    y con un peso máximo de "2048" KB.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* AUTORIZACION DATOS PERSONALES */}

          <div className="contTipoid">
            <div className="contPregunta">
              <div className="labelform">
                <label For="autorizacion"> (*) Autorización de datos personales </label>
              </div>
            </div>
            <div className="contRespuesta2">

              <div className="contAuto">
                <input
                  name='autorizacion'
                  value={formState.autorizacion}
                  onChange={onInputChange}
                  className="autorizacioncheck"
                  type="checkbox"
                  id='idAuto'
                  tabIndex={5}
                  required />
              </div>

              <div>
                <p className="parrafoAut">
                  Con el envío del presente formulario en cumplimiento de la Ley 1581 de 2012 y
                  Decreto 1377 de 2013, autorizo a VEHICENTRO COLOMBIA S.A.S y a sus encargados
                  para el tratamiento de los datos suministrados de conformidad con nuestra política
                  de protección de datos personales que podrá consultar en www.vehicentro.com/co si
                  tienes dudas sobre el uso dado a tus datos envíenos un correo a: contactoco@vehicentro.com
                </p>
              </div>

            </div>
          </div>


        </div>



      </div>
      <br />

    </div >

  )
}
